import { NextRouter } from 'next/router';

import { safeParseFilters } from '@scripts/helpers';

import { FormValues } from '../../../../types';
import { normalizeFieldName } from '../../../../utils/fieldNames';

export const reorderFormValues = (
    transformedValues: FormValues,
    lastChangedBlockHistory: string[],
    fieldPrefix: string
): FormValues => {
    const reorderedValues: FormValues = {};
    const otherKeys: string[] = [];
    const changedBlockKeys: string[] = [];

    const changedKeysSet = new Set(lastChangedBlockHistory);

    Object.keys(transformedValues).forEach(key => {
        const normalizedKey = normalizeFieldName(key, fieldPrefix);
        if (changedKeysSet.has(normalizedKey)) {
            changedBlockKeys.push(key);
        } else {
            otherKeys.push(key);
        }
    });

    otherKeys.forEach(key => {
        reorderedValues[key] = transformedValues[key];
    });

    lastChangedBlockHistory.forEach(normalizedKey => {
        const matchingKey = changedBlockKeys.find(key => {
            const keyNormalized = normalizeFieldName(key, fieldPrefix);

            return keyNormalized === normalizedKey;
        });

        if (matchingKey) {
            const value = transformedValues[matchingKey];
            const isEmpty = Array.isArray(value)
                ? value.length === 0
                : value === undefined || value === null || value === false;

            if (!isEmpty) {
                reorderedValues[matchingKey] = value;
            }
        }
    });

    return reorderedValues;
};

export const parseFiltersHistoryFromUrl = (query: NextRouter['query']): string[] => {
    if (!query.filters) {
        return [];
    }

    const filters = safeParseFilters(query.filters);

    if (!filters || typeof filters !== 'object') {
        return [];
    }

    const filterKeys = Object.keys(filters);

    const normalizedKeys: string[] = [];

    filterKeys.forEach(key => {
        if (key === 'is_profitable') {
            return;
        }

        if (key === 'is_hit') {
            return;
        }

        const value = filters[key];

        if (key === 'isPreOrder') {
            if (value === false) {
                normalizedKeys.push('popup_isPreOrder');
            }

            return;
        }

        const isEmpty = Array.isArray(value)
            ? value.length === 0
            : value === undefined || value === null || value === false;

        if (isEmpty) {
            return;
        }

        if (key === 'price') {
            normalizedKeys.push('price');
        } else {
            normalizedKeys.push(key);
        }
    });

    return normalizedKeys;
};
